var map = {
	"./bicen-1.gif": "3d41",
	"./birdlife-1.png": "269b",
	"./cny-1.png": "8b28",
	"./cny-2.png": "f218",
	"./covid-1.png": "7915",
	"./covid-2.png": "5335",
	"./hajj-1.png": "2b1c",
	"./lhl-1.png": "4729",
	"./love-1.png": "6464",
	"./noodles-1.png": "cbfe",
	"./noodles-2.png": "5088"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "52bd";